<template>
  <v-container fluid>
    <v-form ref="form" @submit.prevent="save(false)">
      <v-row>
        <form-header :title="isEditing ?'Modifica prodotto' : 'Nuovo prodotto'"
                     @back="$router.replace(`/kits/${$route.params.kitId}/products`)" @saveback="save(true)" :loading="loading"></form-header>
        <v-col cols="12" >
          <h3>Info generali</h3>
        </v-col>
        <v-col cols="12" md="6" lg="4" xl="3">
          <v-text-field
              label="Titolo*"
              v-model="editingItem.title.it"
              :rules="[rules.required]"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="6" lg="4" xl="3">
          <v-text-field
              label="Codice Prodotto (SKU)*"
              v-model="editingItem.sku"
              hint="codice univoco prodotto per il sistema di vendita. es: SKU00001, M4KIT00001, ABC12345, 01234XYZ, ecc."
              persistent-hint
              :rules="[rules.required]"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="6" lg="4" xl="3">
          <v-select
              label="Tipologia prodotto*"
              v-model="editingItem.type"
              :items="productTypeOptions"
              :rules="[rules.required]"
          ></v-select>
        </v-col>
        <v-col cols="12" md="6" lg="4" xl="3">
          <v-text-field
              label="Prezzo*"
              prefix="€"
              :step="0.01"
              min="0"
              type="number"
              v-model="editingItem.price"
              :hint="ivaPrice"
              persistent-hint
              :rules="[rules.required, rules.minFloat(0)]"
          ></v-text-field>
        </v-col>

        <v-col cols="12" md="6" lg="4" xl="3">
          <v-text-field
              label="Prezzo al riacquisto"
              prefix="€"
              :step="0.01"
              min="0"
              type="number"
              v-model="editingItem.second_price"
              :hint="ivaSecondPrice"
              persistent-hint
              :rules="[rules.minFloat(0)]"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="6" lg="4" xl="3">
          <v-textarea
              label="Descrizione*"
              v-model="editingItem.description.it"
              :rules="[rules.required]"
          ></v-textarea>
        </v-col>


        <v-col cols="12">
          <h3>Impostazioni</h3>
        </v-col>

        <v-col cols="12" v-if="editingItem.type === 'video'">
          <v-row >
            <v-col cols="12" md="6" lg="4" xl="3">
              <v-text-field
                  label="Intervallo giorni tra una lezione e l'altra*"
                  :step="1"
                  min="0"
                  type="number"
                  v-model="editingItem.days_interval"
                  :rules="[rules.required, rules.minFloat(0)]"
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="6" lg="4" xl="3">
              <v-switch
                  label="Per questo prodotto è prevista una spedizione"
                  hint="es. kit in omaggio o altro"
                  persistent-hint
                  v-model="editingItem.expedition"></v-switch>
            </v-col>
          </v-row>

        </v-col>
        <v-col cols="12" v-else>
          <v-row >
            <v-col cols="12" md="6" lg="4" xl="3">
              <v-select
                  label="Sottocategoria prodotto*"
                  v-model="editingItem.subcategory_id"
                  :items="subcategoriesOptions"
                  :rules="[rules.required]"
              ></v-select>
            </v-col>
            <v-col cols="12" md="6" lg="4" xl="3" v-if="editingItem.type === 'mixed'">
              <v-select
                  label="Tipologia sedute*"
                  v-model="editingItem.seats_types"
                  :items="seatsTypeOptions"
                  multiple chips closable-chips
                  :rules="[rules.required, rules.notEmpty]"
              ></v-select>
            </v-col>
            <v-col cols="12" md="6" lg="4" xl="3" v-if="editingItem.type === 'mixed'" class="d-flex align-center">
              <v-switch v-model="editingItem.consumable" class="mr-3"></v-switch>
              <v-text-field  label="N° sedute" v-model="editingItem.num_seats" type="number" :disabled="!editingItem.consumable" :step="1" :min="0"
                             :rules="editingItem.consumable ? [rules.minInt(1)] : []">

              </v-text-field>
            </v-col>
            <v-col cols="12" md="6" lg="4" xl="3" v-if="editingItem.type === 'mixed'" >
              <v-text-field  label="Durata pacchetto" v-model="editingItem.num_seats" type="number" :step="1" :min="0"
                             hint="durata in giorni delle sedute dal primo utilizzo" persistent-hint :rules="[rules.minInt(1)]">

              </v-text-field>
            </v-col>

            <v-col cols="12"  v-if="editingItem.type === 'distinct'">
              <div class="d-flex align-center flex-wrap">
                <h3 class="mr-2">Pacchetti sedute</h3>
                <v-checkbox label="Le sedute hanno una scadenza condivisa" v-model="editingItem.seats_has_same_expiration" hide-details></v-checkbox>
              </div>


              <v-table class="mt-3 border rounded">
                <thead>
                <tr>
                  <th class="text-center" style="width: 100px">Chi Comanda?</th>
                  <th class="text-left">Tipologia sedute</th>
                  <th class="text-left">A consumo?</th>
                  <th class="text-left">N° sedute</th>
                  <th class="text-left">Durata (giorni)</th>
                  <th class="text-center" style="width: 60px"><v-btn variant="elevated" size="small" color="primary" icon="mdi-plus" @click="dialog = true"></v-btn></th>
                </tr>
                </thead>
                <tbody>
                <tr v-if="!editingItem.seats || !editingItem.seats.length">
                  <td colspan="6" class="font-italic">Al momento non ci sono sedute inserite</td>
                </tr>
                <tr v-for="(item,i) in editingItem.seats" :key="`seats_${i}`">
                  <td>
                    <div class="d-flex justify-center w-100 ">
                      <v-checkbox v-model="item.main" class="ma-0" hide-details @update:model-value="onMainSeatsChange(item, i)"></v-checkbox>
                    </div>

                  </td>
                  <td>
                    <v-chip-group v-if="item.seats_types">
                      <v-chip size="small" v-for="(s,j) in item.seats_types" :key="`seats_type_${i}_${j}`">{{getSeatsName(s)}}</v-chip>
                    </v-chip-group>
                  </td>
                  <td><strong v-if="item.consumable" class="text-primary">Sì</strong><span v-else>No</span></td>
                  <td>{{ item.consumable ? item.num_seats : '-'}}</td>
                  <td>{{ item.duration }}</td>
                  <td><v-btn variant="text" icon="mdi-close" color="error" @click="removeSeat(i)"></v-btn></td>
                </tr>
                </tbody>
              </v-table>
            </v-col>
          </v-row>
        </v-col>

        <form-footer @back="$router.replace(`/kits/${$route.params.kitId}/products`)" @saveback="save(true)" :loading="loading"></form-footer>
      </v-row>

    </v-form>

    <v-dialog v-model="dialog" max-width="800">
      <v-card>
        <v-form ref="addSeatForm" @submit.prevent="addSeat()">
          <v-card-title>
            Aggiungi un pacchetto sedute
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="12" >
                <v-select  label="Tipologia sedute" :items="seatsTypeOptions" v-model="newSeat.seats_types"
                           :rules="[rules.required, rules.notEmpty]" multiple chips closable-chips ></v-select>
              </v-col>
              <v-col cols="12" md="6"  class="d-flex align-center">
                <v-switch v-model="newSeat.consumable" class="mr-3"></v-switch>
                <v-text-field  label="N° sedute" v-model="newSeat.num_seats" type="number" :disabled="!newSeat.consumable"
                               :rules="newSeat.consumable ? [rules.required] : []" :step="1" :min="0">
                </v-text-field>
              </v-col>
              <v-col cols="12" md="6" >
                <v-text-field  label="Durata sedute" v-model="newSeat.duration" type="number" step="1" min="1"
                               hint="durata in giorni delle sedute dal primo utilizzo" persistent-hint :rules="[rules.required, rules.minInt(1)]"></v-text-field>
              </v-col>
            </v-row>

          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn @click="dialog = false">Annulla</v-btn>
            <v-btn variant="elevated" color="primary" type="submit">Aggiungi seduta</v-btn>
          </v-card-actions>
        </v-form>

      </v-card>
    </v-dialog>
  </v-container>
</template>

<script lang="ts">
import utils from "../utils";
import rules from "../utils/rules";
import FormHeader from "@/components/FormHeader.vue";
import FormFooter from "@/components/FormFooter.vue";
import {computed, inject, onMounted, ref, useTemplateRef} from "vue";
import type {Auth} from "@/plugins/auth.ts";
import {type Messages, Msg} from "@/plugins/messages.ts";
import type {Globals} from "@/plugins/globals.ts";
import {useRoute, useRouter} from "vue-router";
import api from "@/api";
import {VForm} from "vuetify/components";
import {type KitDisplay, type Product, type ProductSeats, SeatsType, seatsTypeOptions} from "@/models.ts";
import {productType, productTypeOptions} from "@/consts.ts";
import config from "@/config.ts";

export default {

  components: {FormFooter, FormHeader},
  setup() {
    const auth = inject('auth') as Auth
    const messages = inject('messages') as Messages
    const globals = inject('globals') as Globals
    const route = useRoute()
    const router = useRouter()
    const form = useTemplateRef<typeof VForm>('form')
    const addSeatForm = useTemplateRef<typeof VForm>('addSeatForm')
    const loading = ref(false)
    const dialog = ref(false)

    const kit = ref<KitDisplay|undefined>()

    const newSeat = ref<ProductSeats>({
      consumable: false, duration: 0, main: false, num_seats: 0, seats_types: []
    })

    const editingItem = ref<Product>({
      consumable: false,
      days_interval: 0,
      description: {it:''},
      expedition: false,
      is_seats_product: false,
      num_seats: 0,
      price: 0,
      seats_duration: 0,
      seats_has_same_expiration: false,
      seats_types: [],
      second_price: 0,
      sku: "",
      title: {it:''},
      type: "distinct"
    })
    
    const loadKit = async () => {
      loading.value = true;
      let id = route.params.kitId as string;
      const res = await api.get<KitDisplay>('kits', id)
      loading.value = false
      if(!res.success) {
        messages.error(res.message ?? Msg.serverError)
        await router.replace('/kits')
        return;
      }
      kit.value = res.data!
      editingItem.value.kit_id = kit.value._id
    }

    const loadData = async () => {
      loading.value = true;
      let id = route.params.id as string;
      const res = await api.get<Product>('products', id)
      if(!res.success) {
        loading.value = false;
        messages.error(res.message ?? Msg.serverError)
        await router.replace(`/kits/${route.params.kitId}/products`)
        return
      }
      editingItem.value = res.data!
      loading.value = false;
    }

    onMounted(async ()=>{
      await globals.waitForInit
      await router.isReady()
      await Promise.all([
        globals.refreshEmpty('subcategories')
      ])
      if (route.params.id !== "new") {
        await loadData();
      }
    })




    return {
      dialog,
      form,
      addSeatForm,
      loading,
      newSeat,
      isEditing : computed(()=> route.params.id !== "new"),
      editingItem,
      rules,
      formatDate : utils.formatDate,
      productTypeOptions,
      seatsTypeOptions,
      subcategoriesOptions : computed(()=>{
        return globals.subcategories.value.map(i => {
          return { title : i.name.it, value : i._id}
        })
      }),
      ivaPrice : computed(()=>{
        let price = utils.toFloat(editingItem.value.price, 0);
        const iva = price / 100 * config.iva;
        return `+ iva al ${config.iva}% = ${(price + iva).toFixed(2)}€`;
      }),
      ivaSecondPrice : computed(()=>{
        let price = utils.toFloat(editingItem.value.second_price, 0);
        if(!price) {
          return "lascia a zero se non vuoi un che abbia un secondo prezzo al riacquisto"
        }
        const iva = price / 100 * config.iva;
        return `+ iva al ${config.iva}% = ${(price + iva).toFixed(2)}€`;
      }),
      onMainSeatsChange(item:ProductSeats, i:number) {
        if(item.main) {
          for(let j = 0; j < editingItem.value.seats!.length; j++) {
            editingItem.value.seats![j].main = i === j;
          }
        } else {
          if(i === 0 && editingItem.value.seats!.length >= 2) {
            editingItem.value.seats![1].main = true
          }
          if(i > 0) {
            editingItem.value.seats![0].main = true
          }
        }


      },
      getSeatsName(s:SeatsType) {
        /*
        <v-chip small v-if="item.is_seats_product && item.seats_types && item.seats_types.includes('topgymexperience')">TopGym Experience</v-chip>
                      <v-chip small v-if="item.is_seats_product && item.seats_types && item.seats_types.includes('opengym')">Open Gym</v-chip>
                      <v-chip small v-if="item.is_seats_product && item.seats_types && item.seats_types.includes('corsi')">Sala Corsi</v-chip>
                      <v-chip small v-if="item.is_seats_product && item.seats_types && item.seats_types.includes('onetoone')">One-to-One</v-chip>
                      <v-chip small v-if="item.is_seats_product && item.seats_types && item.seats_types.includes('gym')">Ginnastica e Corpo Libero</v-chip>
                      <v-chip small v-if="item.is_seats_product && item.seats_types && item.seats_types.includes('vacu')">Vacu</v-chip>
         */
        switch (s) {
          case SeatsType.exp:
            return "Top Gym Experience"
          case SeatsType.opengym:
            return "Open Gym"
          case SeatsType.corsi:
            return "Sala corsi"
          case SeatsType.gym:
            return "Bike indoor"
          case SeatsType.vacu:
            return "Vacu"
        }
        return s
      },
      removeSeat(i:number) {
        messages.requestConfirm('Richiesta conferma',  'Sei sicuro di voler eliminare questo elemento?', false, ( accepted )=>{
          if(accepted) {
            editingItem.value.seats!.splice(i,1)
          }
        });
      },
      async addSeat() {
        const { valid } = await addSeatForm.value!.validate()
        if(!valid) return;

        newSeat.value.num_seats = utils.toInt(newSeat.value.num_seats, 0)
        newSeat.value.duration = utils.toInt(newSeat.value.duration, 1)
        if(!editingItem.value.seats) editingItem.value.seats = []
        if( editingItem.value.seats.filter(s => s.main).length === 0) {
          newSeat.value.main = true;
        }

        editingItem.value.seats.push({...newSeat.value})

        newSeat.value = {
          seats_types : [],
          num_seats : 0,
          consumable : false,
          duration : 0,
          main : false
        }
        dialog.value=false
      },
      async save(goBackAfterSave:boolean) {
        editingItem.value.price = utils.toFloat(editingItem.value.price, 0);
        if(editingItem.value.type === productType.video) {
          editingItem.value.days_interval = utils.toInt(editingItem.value.days_interval, 0);
        }
        editingItem.value.second_price = utils.toFloat(editingItem.value.second_price, 0);
        if(editingItem.value.type === productType.mixed) {
          if(editingItem.value.consumable) {
            editingItem.value.num_seats = utils.toInt(editingItem.value.num_seats, 0)
          } else {
            editingItem.value.num_seats = 0;
          }
          editingItem.value.seats_duration = utils.toInt(editingItem.value.seats_duration, 0)
        }

        if(editingItem.value.type === productType.distinct && (!editingItem.value.seats || !editingItem.value.seats.length)) {
          messages.error('Inserisci almeno un pacchetto sedute!')
          return;
        }
        
        const v = await form.value!.validate()
        if(!v.valid) return;
        loading.value = true;
        const res = await api.save<any>('products', editingItem.value)
        loading.value = false;
        if(!res.success) {
          messages.error(res.message ?? Msg.serverError)
          if(res.status === 401) {
            auth.logout()
          }
          return
        }
        editingItem.value = res.data!
        messages.success("prodotto salvato")
        if(goBackAfterSave) {
          await router.replace(`/kits/${route.params.kitId}/products`)
        } else if(route.params.id === 'new'){
          await router.replace(`/kits/${route.params.kitId}/products/${editingItem.value._id}`)
        }
      }
    };
  }
};
</script>

<style scoped></style>
